module.exports = function() {
  return new Worker(__webpack_public_path__ + "eb068a4581d23bd387ae.worker.js");
};